(() => {
  const bar = document.querySelector('[data-miromor-sticky-atc]');
  const mainButton = document.querySelector('product-form form [type="submit"]');
  if (!bar || !mainButton) return;
  const phone = window.matchMedia('(max-width: 749px)');
  let mainOnScreen = true;
  const update = () => {
    const show = phone.matches && !mainOnScreen;
    bar.hidden = !show;
    document.body.classList.toggle('miromor-has-sticky-atc', show);
  };
  new IntersectionObserver(([entry]) => { mainOnScreen = entry.isIntersecting; update(); }).observe(mainButton);
  phone.addEventListener('change', update);
  bar.querySelector('button').addEventListener('click', () => mainButton.click());
})();
